import React from "react";
import { RotateCw } from "lucide-react";

import useGetResources from "../../hooks/useGetResources";
import LoadingSpinner from "../components/LoadingSpinner";
import { Card, CardHeader, CardTitle, CardContent } from "components/ui/card";
import { Button } from "components/ui/button";
import { Spinner } from "components/ui/spinner";
import {
    Table,
    TableHeader,
    TableBody,
    TableRow,
    TableHead,
    TableCell,
} from "components/ui/table";

function Instances({ eventId, environment, theme }) {
    const { resources, error, isLoaded, refetchResources, isRefetching } = useGetResources(
        eventId,
        environment,
        "get_event_instances"
    );

    if (!isLoaded) {
        return <LoadingSpinner />;
    }

    return (
        <Card>
            <CardHeader className="flex-row items-center gap-3 space-y-0 border-b border-border">
                <CardTitle className="text-base">Instances</CardTitle>
                <Button
                    size="icon-sm"
                    onClick={refetchResources}
                    title="Refresh"
                    disabled={isRefetching}
                >
                    <RotateCw />
                </Button>
                {isRefetching && <Spinner className="h-4 w-4" />}
            </CardHeader>
            {resources.length > 0 ? (
                getInstanceTable()
            ) : (
                <CardContent className="pt-4">
                    <p>No instance found!</p>
                </CardContent>
            )}
        </Card>
    );

    function getInstanceTable() {
        return (
            <Table>
                <TableHeader>
                    <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>State</TableHead>
                        <TableHead>Instance Type</TableHead>
                        <TableHead>Instance ID</TableHead>
                        <TableHead>Launch Time</TableHead>
                        <TableHead>Private IP Address</TableHead>
                        <TableHead>Public IP Address</TableHead>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {resources.map((resource, index) => (
                        <TableRow key={index}>
                            <TableCell>{resource.instanceName}</TableCell>
                            <TableCell className={getInstanceColor(resource.state)}>
                                {resource.state}
                            </TableCell>
                            <TableCell>{resource.instanceType}</TableCell>
                            <TableCell>{resource.instanceId}</TableCell>
                            <TableCell>{resource.launchTime}</TableCell>
                            <TableCell>{resource.privateIpAddress}</TableCell>
                            <TableCell>{resource.publicIpAddress}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        );
    }
}

export default Instances;

function getInstanceColor(state) {
    switch (state) {
        case "running":
            return "text-success";
        case "starting":
            return "text-warning";
        case "terminated":
            return "text-muted-foreground";
        default:
            return "";
    }
}
